export const initialGdprErasureLogTable = {
    items: [],
    totalElements: 0,
    page: 0,
    size: 20,
    loading: false,
    filters: {
        firstName: "",
        lastName: "",
        email: "",
        receiptCode: "",
        requestedBy: "",
    },
};
